import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {GameFeatureMode} from "../enums/Enum";
import {gsap} from "gsap";

export class SFSOutroRunner implements SimplePresentation {
    shouldRun(): boolean {
        return Game.model.gameData.mode === GameFeatureMode.FREESPIN_SUPER && Game.model.gameData.nextMode === GameFeatureMode.NORMAL && !Game.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        controller.setSkipCallback(undefined);
        tl.add(() => Game.keypadPlugin.setZeroBetSpinCounter(-1));
        tl.add(gsap.to(this, {duration: 1}));
        tl.add(Game.sfsOutroView.show(() => this.closeCallback(controller), Game.model.data.accumulatedRoundWin, 2))
    }

    private closeCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

}